import React from 'react'
import {Center, Spinner} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Reusable page loading component with centered spinner
 * Used across all page types for consistent loading state
 */
const PageLoader = () => {
    return (
        <Center minH="90vh">
            <Spinner size="xl" color="black" thickness="4px" />
        </Center>
    )
}

export default PageLoader
